import type { AgentActivitySummary } from "@/pages/agent/activities/agent-activity.types";

export const USER_FACING_AGENT_ACTIVITY_EXCLUDED_ITEM_KINDS = [
  "follow_up.scheduled",
  "follow_up.updated",
  "follow_up.rescheduled",
  "follow_up.completed",
  "follow_up.cancelled",
  "follow_up.deleted",
  "follow_up.read",
  "follow_ups.reviewed",
];

/**
 * Hides routine activity only when its source resolves to a currently known fixed routine.
 * Unresolved historical routine activity remains visible.
 */
export const isUserFacingAgentActivity = ({
  activity,
  fixedRoutineIds,
}: {
  activity: AgentActivitySummary;
  fixedRoutineIds: ReadonlySet<string>;
}): boolean => {
  if (activity.activity_type !== "agent.routine") {
    return true;
  }

  const sourceReference = activity.source.reference;
  if (sourceReference?.kind !== "routine") {
    return true;
  }

  return !fixedRoutineIds.has(sourceReference.id);
};
